import { render, staticRenderFns } from "./ReminderInfo.vue?vue&type=template&id=31a03a3d&scoped=true"
import script from "./ReminderInfo.vue?vue&type=script&lang=js"
export * from "./ReminderInfo.vue?vue&type=script&lang=js"
import style0 from "./ReminderInfo.vue?vue&type=style&index=0&id=31a03a3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a03a3d",
  null
  
)

export default component.exports